<template lang="pug">
vm-row.heading(vm-w="12")
  vm-col(vm-type="flex" vm-align="center" vm-lg=12 vm-sm=12)
    div
      h2 {{ $t('quotations.extra_information') }}
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12)
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      span(class="attached-custom__text") {{ $t('quotations.attached_file') }}
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      .attached-custom
        .attached-custom__card(@dragover='dragover' @dragleave='dragleave' @drop='drop')
          div(class="attached-custom__card__placeholder" v-if='!this.filelist.length')
            vm-icon(icon="cloud-upload-outline" size="2rem")
            label(for='files')
              span {{ $t('quotations.description_attached') }}
            vm-button(@click="onDialogFileOpen" size="medium") Buscar archivo
          div(class="attached-custom__card__grid" v-else='')
            div(class="attached-custom__card__grid__item" v-for='(file, index) in filelist' :key="index")
              header
                img(:src='checkFormat(file.name)' @click="onShowFile(file)")
                .attached-custom__card__grid__item__dropdown
                  vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="flat" icon="more-vertical" color="#afbbc6" size="small")
                    vm-dropdown-menu
                      vm-dropdown-item.d-flex.justify-content-between(@click="remove(index, file)")
                        vm-icon(icon="trash-2-outline")
                        slot &nbsp;{{ $t('strings.delete') }}
              footer
                img(:src='checkFormat(file.name)')
                span {{ getFileNameFormated(file.name) }}
            vm-button(@click="onDialogFileOpen" size="medium" class="attached-custom__upload" icon="plus" v-if="")
        input(class="attached-custom__file" id="files" type='file' multiple='' name='fields[files][]' @change='onChange' ref='file' accept='.pdf,.dwg,.xls,.spread,.dxf,.xlsx,.csv')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      vm-textarea(class="attached-custom__note" height="120px" :placeholder='$t("quotations.write_here")' v-model="form.comments" @keyup.enter="setBullets(form.comments)" type="text" :label='$t("quotations.notes")')
</template>
<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('Quotations')
export default {
  name: 'QuotationExtraInformationForm',
  mixins: [ViewMixinMaster1],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    filelist: []
  }),
  computed: {
  },
  watch: {
    'form.id' () {
      this.filelist.push(...this.form.files)
    }

  },
  methods: {
    ...mapActions([
      'deletedFile',
      'printDownloadPDF',
      'openFile'
    ]),
    onDialogFileOpen () {
      this.$refs.file.click()
    },
    onShowFile (file) {
      const ext = file.name.split('.').pop()
      if (file.id && ext === 'pdf') {
        this.$viewer.show({
          urlFile: file.file_url,
          mime: file.mime_type,
          name: file.name,
          color: '#FFF'
        })
      } else if (file.id && ext !== 'pdf') {
        this.openFile(file.file_url)
      }
    },
    onChange () {
      this.filelist.push(...this.$refs.file.files)
      this.$refs.file.value = ''
      this.$emit('onChange', this.filelist)
    },
    async remove (index, file) {
      if (file.id) {
        await this.deletedFile({ id: file.id })
      }
      this.filelist.splice(index, 1)
    },
    dragover (event) {
      event.preventDefault()
      if (!event.currentTarget.classList.contains('attached-custom__card--dragover')) {
        event.currentTarget.classList.add('attached-custom__card--dragover')
      }
    },
    dragleave (event) {
      event.currentTarget.classList.remove('attached-custom__card--dragover')
    },
    drop (event) {
      event.preventDefault()
      this.$refs.file.files = event.dataTransfer.files
      this.onChange()
      event.currentTarget.classList.remove('attached-custom__card--dragover')
    },
    getFileNameFormated (file) {
      return file.replace(/\.[^/.]+$/, '')
    },
    checkFormat (file) {
      const type = file.split('.').pop()
      if (type === 'dwg' || type === 'dxf') {
        return require('@/assets/icons/auto.png')
      } else if (type === 'pdf') {
        return require('@/assets/icons/pdf.svg')
      } else if (type === 'xls' || type === 'spread' || type === 'xlsx' || type === 'csv') {
        return require('@/assets/icons/excel.svg')
      } else {
        return require('@/assets/icons/auto.png')
      }
    },
    setBullets (payload) {
      const bullet = '•'
      this.form.comments = `${payload}${bullet} `
    }
  }
}
</script>

<style lang="scss">
.attached-custom {
  margin: 20px 0;
  &__card {
    background-color: #F2F4F7;
    display: flex;
    min-height: 150px;
    border-radius: 8px;
    border: 3px dashed #B1B1B1;
    padding: 25px 35px;
    position: relative;
    &--dragover {
      background-color: rgba($color: var(--success), $alpha: 0.5);
      border: 3px dashed rgba($color: var(--success), $alpha: 1.0);
    }
    &__placeholder {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      & label {
        margin: 16px 0 10px 0;
        & span {
          font-size: 14px;
          font-weight: 400;
          color: #8A8A8A;
        }
      }
      & button {
        font-weight: 700;
        font-size: 16px;
      }
    }
    &__grid {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 20px;
      &__item {
        background-color: white;
        border-radius: 0.5em;
        box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.25);
        -webkit-box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.25);
        -moz-box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.25);
        cursor: pointer;
        &__dropdown {
          position: absolute;
          top: 0;
          right: 0;
        }
        & header {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 125px;
          border-bottom: 1px solid #f0f0f0;
          padding: 10px;
          position: relative;
          img {
            width: 50px;
          }
        }
        & footer {
          padding: 10px;
          display: flex;
          & img {
            width: 20px;
            margin-right: 10px;
          }
        }
      }
    }
  }
  &__file {
    display: none;
  }
  &__upload {
    position: absolute;
    bottom: 5px;
    right: 5px;
    border-radius: 50%;
  }
  // remove clasess
  &__text {
    font-weight: bold;
  }
  &__note {
    label {
      color: black;
      font-weight: bold;
    }
  }
}
[v-cloak] {
  display: none;
}
</style>
